import { cn } from '@/lib/utils'

export function Empty({ className, children = '暂无数据', ...rest }: React.ComponentProps<'div'>) {
  return (
    <div className={cn('w-full py-6 text-center text-muted-foreground', className)} {...rest}>
      {children}
    </div>
  )
}
